import type { FC, ReactNode } from 'react'
import type { TeamMember as TeamMemberType } from '@/types'

interface TeamMemberProps {
    member: TeamMemberType
}

const SOCIAL_ICONS: Record<string, string> = {
    youtube: '/images/youtube.svg',
    linkedin: '/images/linkedin.svg',
    twitter: '/images/x-twitter.svg',
    facebook: '/images/facebook.svg',
    pinterest: '/images/pinterest.svg',
    instagram: '/images/instagram.svg'
}

export const TeamMember: FC<TeamMemberProps> = ({ member }): ReactNode => {
    return (
        <div className='team-member-item-parent'>
            <div className='team-member-bg-holder'>
                <div className='team-member-item-bg' />
            </div>
            <div className='team-member-item'>
                <div className='team-member-content'>
                    <div className='team-member-main-content'>
                        <div className='team-member-item-title' data-mdlfy-cms={`team_members:${member.id}:name`}>
                            {member.name}
                        </div>
                        <div className='team-member-bio' data-mdlfy-cms={`team_members:${member.id}:role`}>
                            {member.role}
                        </div>
                    </div>
                    <div className='team-member-social-media-icons'>
                        <div className='social-media-icons'>
                            {member.socials.map((social, i) => (
                                <a
                                    key={`${social.platform}-${i}`}
                                    className={`social-media-link _${i + 1} mdl-inline-block`}
                                    href={social.url}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    aria-label={`${member.name} on ${social.platform}`}
                                >
                                    <img
                                        className='social-media-icon'
                                        src={SOCIAL_ICONS[social.platform] ?? '/images/linkedin.svg'}
                                        alt=''
                                    />
                                    <div className='link-background' />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                {member.imageUrl && (
                    <div className='team-member-image-holder'>
                        <img className='team-member-image' src={member.imageUrl} loading='lazy' alt={member.imageAlt || member.name} />
                    </div>
                )}
            </div>
        </div>
    )
}
